import React from 'react';
import Document from './Document';
import PDocumentRedirect from './pages/PDocumentRedirect';

const DocumentRoutes = {
	dashboard: {
		tag: 'documents_dashboard',
		path: '/documents',
		auth: true,
		layout: 'investor',
		component: <Document page="dashboard" />,
	},
	documents_expertise: {
		tag: 'documents_expertise',
		path: '/documents/expertises/:investExpertiseTag',
		auth: true,
		layout: 'investor',
		component: <Document page="documents_expertise" />,
	},
	documents_fund: {
		tag: 'documents_fund',
		path: '/documents/expertises/:investExpertiseTag/fund/:investFundId',
		auth: true,
		layout: 'investor',
		component: <Document page="documents_fund" />,
	},
	documents_company: {
		tag: 'documents_company',
		path: '/documents/company',
		auth: true,
		layout: 'investor',
		component: <Document page="documents_company" />,
	},
	documents_search: {
		tag: 'documents_search',
		path: '/documents/search',
		auth: true,
		layout: 'investor',
		component: <Document page="documents_search" />,
	},
	redirect_document: {
		tag: 'redirect_document',
		path: '/redirect/edm/:edm_id/document/:edm_document_id', // NE PAS CHANGER CAR TRANSMIS AU PARTENAIRE ex : http://localhost:8080/redirect/edm/0/document/12694 pour ABEILLE GROUP
		auth: true,
		component: <PDocumentRedirect />,
	},
	document: {
		tag: 'document',
		path: '/documents/:id',
		auth: true,
		layout: 'investor',
		component: <Document page="document" />,
	},
};

export default DocumentRoutes;
